// Entry point: renders the App component into the DOM.

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Global resets & base styling
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: Measure performance
reportWebVitals();
